import { Button, Radio, Result, Skeleton } from 'antd';
import React, { useEffect, useState } from 'react';
import { BsGraphUp, BsPeople } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import CurrencyIcon from '../../Common/CurrencyIcon';
// import './ProfileEarnStatsComponent.styles.scss';

const ProfileEarnStatsComponent = ({ loading, platformData }) => {
  const [selVal, setSelVal]= useState('');
  const [stats, setStats] = useState({

  });
  const optionsWithDisabled = [
    { label: 'Instagram', value: 'instagram', disabled: !loading && !platformData.instagram.enabled },
    { label: 'Twitter', value: 'twitter', disabled: !loading && !platformData.twitter.enabled },
    { label: 'Youtube', value: 'youtube', disabled: !loading && !platformData.youtube.enabled },
  ];
  const onChangePlatform = (e) =>{
    setSelVal(e.target.value);
  };

  useEffect(()=>{
    // note: load first available platform
    if (!loading) {
      const _firstTobeEnabled = [];
      for (const [key, value] of Object.entries(platformData)) {
        console.log(`${key}: ${value}`);
        if (value.enabled === true) {
          _firstTobeEnabled.push(key);
        }
      }
      setStats({
        ...platformData[_firstTobeEnabled[0]],
      });
      setTimeout(()=>{
        setSelVal(_firstTobeEnabled[0] || '');
        console.log('_stats', stats);
      }, [100]);
    }
  }, [loading]);
  return loading ?
    (
      <div className="col-md-7 col-lg-6 my-3 px-2">
        <div className="common_card p-3 profile_stats_card h-100">
          <Skeleton active/>
        </div>
      </div>
    ):(
      <div className="col-md-7 col-lg-6 my-3 px-2">
        <div className="common_card p-3 profile_stats_card h-100 d-flex flex-column justify-content-between">
          {selVal === ''?(
            <>
              <div className="profile_stats_noplatform d-flex align-items-center justify-content-center h-100">
                <div className="">
                  <h4>No Platforms connected</h4>
                  <p>Please consider connecting your social platform for details</p>
                  <Link to="/influencer/profile?tab=1"
                    className="common_button">Connect Platform</Link>
                </div>
              </div>
            </>
          ):(

            <>
              <div className="profile_stats_card_top">
                <div className="d-flex justify-content-between">
                  <h4 className="profile_stats_card_top--title">Earning Potential</h4>
                  <div className="profile_stats_card_toggles">
                    <Radio.Group
                      options={optionsWithDisabled}
                      onChange={onChangePlatform}
                      value={selVal}
                      optionType="button"
                      buttonStyle="solid"
                    />
                  </div>
                </div>
              </div>
              <div className="profile_stats_card_middle">
                <p className="profile_stats_card_middle--subtitle m-0">Avg. Earning per post</p>
                <div className="profile_stats_card_middle--costrange">{CurrencyIcon()} N/A</div>
              </div>
              <div className="profile_stats_card_bottom">
                <div className="d-flex justify-content-between">
                  <div className="profile_stats_card_bottom_left">
                    <p className="profile_stats_card_middle--subtitle m-0">Historic Engagement Rate</p>
                    <div className="profile_stats_card_middle--costrange"><BsGraphUp size={16}
                      color={'#777'}/> {stats.engagementMax || 'N/A'} </div>
                  </div>
                  <div className="profile_stats_card_bottom_right">
                    <p className="profile_stats_card_middle--subtitle m-0">Total Followers</p>
                    <div className="profile_stats_card_middle--costrange"><BsPeople size={16}
                      color={'#777'}/> {stats.followingSubscribers || 'N/A'}</div>
                  </div>
                </div>
              </div>
            </>
          )

          }
        </div>
      </div>
    );
};

export default ProfileEarnStatsComponent;
